<template>
    <div class="ProjectMaterialSelector">
        <div>
            <FormInput v-model="search" placeholder="Search for material..." @input="handleSearch"/>
            <span>{{ materialIds.size }} selected</span>
        </div>

        <div class="materialList">
            <button
                v-for="material in filteredMaterials"
                :key="material.id"
                class="materialItem"
                :class="{ selected: isMaterialSelected(material) }"
                @click="handleSelectMaterial(material, isMaterialSelected(material))"
            >
                {{ material.name }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FormSelectMaterial from '@/components/common/FormSelectMaterial';

export default {
    name: 'ProjectMaterialSelector',

    components: { FormSelectMaterial },

    props: {
        materials: { type: Array, default: [] },
    },

    data: () => ({
        search: '',

        materialIds: new Set(),
        filteredMaterials: [],
    }),

    computed: {
        ...mapState('company', { allMaterials: 'materials' }),
    },

    methods: {
        isMaterialSelected(material) {
            return this.materialIds.has(material.id);
        },

        handleSelectMaterial(material, isSelected) {
            if (isSelected) {
                this.materialIds.delete(material.id);
            } else {
                this.materialIds.add(material.id);
            }

            const materials = [...this.materialIds]
                .map(id => this.allMaterials.find(m => m.id === id))
                .filter(material => material);

            this.updateMaterials(materials);
        },

        handleSearch(value) {
            if (!value) {
                this.resetMaterialList();
                return;
            }

            this.filteredMaterials = this.filteredMaterials.filter((material) => {
                const materialName = material.name.toLowerCase().trim();
                const searchInput = value.toLowerCase().trim();
                return materialName.includes(searchInput);
            });
        },

        resetMaterialList() {
            this.filteredMaterials = [...this.allMaterials];
        },

        updateMaterials(materials) {
            // Force component to reload
            this.filteredMaterials = [...this.filteredMaterials];

            this.$emit('update:materials', materials);
        },

        clearAllMaterials() {
            this.materialIds.clear();
            this.updateMaterials([]);
        },
    },

    mounted() {
        this.materials.forEach(material => {
            this.materialIds.add(material.id);
        })

        this.resetMaterialList();
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ProjectMaterialSelector {
    .materialList {
        border: 1px solid $divider-color;
        height: 300px;
        overflow-y: scroll;
    }

    .materialItem {
        @extend %form-control;
        border: none;
        border-radius: 0;
        text-align: left;

        &:hover, &.selected {
            background-color: rgba($link-color, 0.8);
            color: #fff;
        }
    }

    .FormInputContainer {
        margin-bottom: $grid-gutter-width;
    }
}
</style>
